<template>
  <div class="form">
    <slot name="default"></slot>
  </div>
</template>
<script lang="ts">
export const FROM_KEY = Symbol('validate-form');
export type FormProvide = {
  pushValidateList: (validateEffect: () => ({ field: string, rules: any, ifOK: any, ifError: any})) => any;
  pushClearValidate: (clearFunction: () => any) => any;
  setValidateFun: (setFunction: () => {field: string, setFun: (error: any) => any}) => any;
};
</script>
<script setup lang="ts">
import { defineExpose, provide, ref, reactive, defineProps, withDefaults } from 'vue';

const props = withDefaults(defineProps<{
  model: Record<string, any>; // 绑定的表单参数
}>(), {});



const validateList = ref<{ field: string, rules: any, ifOK: any, ifError: any }[]>([]);
const clearValidateFun = ref<any[]>([]);
const setValidateFun = ref<{ field: string, setFun: (error: any) => any}[]>([]);

/**
 * 如何解决三个问题 ？
 * form 进行validate验证 收集到form-item绑定的field，拿到model里面的数据，然后验证到子组件的validate
 * form 进行clear操作 收集form-item里面的所有清除方法
 * form 进行set某一项操作
 */
provide(FROM_KEY, reactive<FormProvide>({
  pushValidateList: (effectFun) => {
    const effect = effectFun();
    validateList.value.push(effect);
  },
  pushClearValidate: (clearFun) => {
    clearValidateFun.value.push(clearFun);
  },
  setValidateFun: (setFunction) => {
    const { field, setFun } = setFunction();
    setValidateFun.value.push({
      field,
      setFun,
    })
  }
}))


const validatePromise = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    let isAllOk = true; // 是否都是好的
    validateList.value.forEach((validate) => {
      const modelValue = props.model[validate.field];
      let isRuleOK = true; // 是否该rule是好的
      (validate.rules ?? []).forEach((rule: { message: string; validator: (bindValue: any) => boolean; }) => {
        const _ruleValue = rule.validator(modelValue);
        if (!_ruleValue) {
          // 如果某一个field的某一个rule不可以， 则全部失败
          isRuleOK = false;
          validate.ifError(rule.message);
          reject(rule);
        } else {
          validate.ifOK();
        }
      });
      if (!isRuleOK) {
        isAllOk = false;
      }
    })
    if (isAllOk) {
      resolve();
    } else {
      reject();
    }
  })
}

// 清除表单状态
const clearValidate = () => {
  clearValidateFun.value.map((fun: any) => fun?.());
}

// 验证表单状态
const validate = () => {
  return validatePromise();
}

// 设置某一项表单状态
const setValidate = (field: string, error:string) =>  {
  const currentSet = setValidateFun.value.find((item) => item.field === field);
  if (currentSet) {
    currentSet.setFun(error);
  }
}

defineExpose<{
  validate: () => any;
  clearValidate: () => any;
  setValidate: (field: string, error:string) => any;
}>({
  validate,
  clearValidate,
  setValidate,
})
</script>
